import styled from "styled-components";

const LinkOuter = styled.div`
    font-size: 15px;

    @media (max-width: 575px) {
        font-size: 13px;
        text-align: center;
    }

    > a {
        line-height: 18px;
        color: #333;
        outline: none !important;
        &:hover {
            color: #333;
        }
    }
`;

export default LinkOuter;
